<template>
  <b-navbar toggleable="md" type="dark">
    <b-navbar-toggle id="nav_toggle" target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand :to="{name: 'Home'}">SmartDine</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="mr-auto">
        <b-nav-item
          v-if="$store.state.stripeConnectUserId && $store.state.tableNumber"
          to="/menu"
        >{{ $t('Navbar.menu') }}</b-nav-item>
        <b-nav-item-dropdown v-if="$store.state.isUserLoggedIn" :text="$t('Navbar.admin')" left>
          <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'Orders'}"
          >{{ $t('Navbar.orders') }}</b-dropdown-item>
          <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'EditCategories'}"
          >{{ $t('Navbar.editCategories') }}</b-dropdown-item>
          <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'EditItems'}"
          >{{ $t('Navbar.editItems') }}</b-dropdown-item>
          <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'EditFilterTags'}"
          >{{ $t('Navbar.editFilterTags') }}</b-dropdown-item>
          <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'ChangePassword'}"
          >{{ $t('Navbar.changePassword') }}</b-dropdown-item>
          <!-- <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'PrinterLanguage'}"
          >{{ $t('Navbar.printerLanguage') }}</b-dropdown-item>-->
          <b-dropdown-item
            v-if="$store.state.user.superuser"
            :to="{name: 'RegistrationInvite'}"
          >{{ $t('Navbar.registrationInvite') }}</b-dropdown-item>
          <b-dropdown-item
            v-if="!$store.state.stripeConnectUserId"
            :to="{name: 'StripeConnectStart'}"
          >Stripe Connect</b-dropdown-item>
          <b-dropdown-item
            v-if="$store.state.isUserLoggedIn"
            :to="{name: 'StripeConnectInfo'}"
          >Stripe</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown :text="$t('Navbar.about')" left>
          <b-dropdown-item :to="{name: 'Contact'}">{{ $t('Navbar.contact') }}</b-dropdown-item>
          <b-dropdown-item :to="{name: 'Legal'}">{{ $t('Navbar.legal') }}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template v-slot:button-content>
            <font-awesome-icon icon="globe" />
          </template>
          <b-dropdown-item v-for="l in locales" :key="l.code" @click="setLanguage(l.code)">
            <div class="navbar-dd-item">
              <country-flag :country="l.flag" size="normal" />
              <span>{{l.name}}</span>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-if="!$store.state.isUserLoggedIn" to="/login">{{ $t('Navbar.login') }}</b-nav-item>
        <b-nav-item v-if="$store.state.isUserLoggedIn" @click="logout">{{ $t('Navbar.logout') }}</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
    <b-navbar-brand
      v-if="$route.path !== '/cart' && $store.state.stripeConnectUserId"
      class="nb-small"
      :to="{name: 'Cart'}"
    >
      <font-awesome-icon icon="shopping-cart" />
      &nbsp;{{ $t('Navbar.cart') }} ({{itemsInCart}})
    </b-navbar-brand>
    <b-navbar-brand
      v-if="windowWidth < 768 && $route.path === '/cart'"
      class="nb-small"
      to="/menu"
    >{{ $t('Navbar.menu') }}</b-navbar-brand>
  </b-navbar>
</template>

<script>
import locales from '../i18n/locales'
export default {
  data () {
    return {
      windowWidth: window.innerWidth,
      locales: locales
    }
  },
  mounted () {
    this.toggleCartView()
    this.toggleMenuCart()
  },
  methods: {
    logout () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$store.dispatch('clearCart')
      this.$store.dispatch('setTableNumber', null)
      this.$router.push({ name: 'Home' })
    },
    toggleCartView () {
      const checkoutCart = document.querySelector('.navbar-brand.nb-small')
      const navCollapse = document.querySelector('#nav_collapse')

      // Callback function to execute when mutations are observed
      const callback = function (mutationsList, observer) {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'attributes') {
            if (mutation.target.className === 'navbar-collapse collapse') {
              checkoutCart.setAttribute('style', 'flex-basis: none;')
            } else if (
              mutation.target.className === 'navbar-collapse collaping'
            ) {
              checkoutCart.setAttribute('style', 'flex-basis: 100%;')
            } else {
              checkoutCart.setAttribute('style', 'flex-basis: 100%;')
            }
          }
        })
      }

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback)

      // Start observing
      observer.observe(navCollapse, { attributes: true })
    },
    toggleMenuCart () {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    },
    setLanguage (langCode) {
      this.$i18n.locale = langCode
    }
  },
  computed: {
    itemsInCart () {
      let cart = this.$store.getters.cartItems
      return cart.reduce((accum, item) => accum + item.quantity, 0)
    }
  }
}
</script>
<style scoped>
.nav-link:active,
.btn:active,
.nav-link.active,
.btn.active {
  font-weight: bold;
}
.navbar-brand.nb-small {
  font-size: 1rem;
}
.navbar-dd-item {
  display: flex;
  align-items: center;
}
.navbar-dd-item > span {
  padding-left: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue